import Highlight from "@tiptap/extension-highlight";
import { TaskItem, TaskList } from "@tiptap/extension-list";
import TextAlign from "@tiptap/extension-text-align";
import { Color, TextStyle } from "@tiptap/extension-text-style";
import { Markdown } from "@tiptap/markdown";
import StarterKit from "@tiptap/starter-kit";
import { Extension } from "@tiptap/core";

import { ImagePlaceholder } from "./imagePlaceholderExtension.mjs";
import { Indent } from "./indentExtension.mjs";
import { PasteMarkdown } from "./markdownPaste.mjs";

const ArticleSemantics = Extension.create({
  name: "articleSemantics",
  addGlobalAttributes() {
    return [
      {
        types: ["heading", "paragraph"],
        attributes: {
          role: {
            default: undefined,
            parseHTML: (element) => element.getAttribute("data-role"),
            renderHTML: ({ role }) => role ? { "data-role": role } : {}
          }
        }
      },
      {
        types: ["heading"],
        attributes: {
          sectionId: {
            default: undefined,
            parseHTML: (element) => element.getAttribute("data-section-id"),
            renderHTML: ({ sectionId }) => sectionId ? { "data-section-id": sectionId } : {}
          }
        }
      }
    ];
  }
});

export function createEditorExtensions({ onTitleFromPaste = () => {} } = {}) {
  return [
    StarterKit.configure({
      heading: { levels: [1, 2, 3, 4, 5] },
      link: { openOnClick: false, protocols: ["http", "https"] }
    }),
    TaskList,
    TaskItem.configure({ nested: true }),
    TextStyle,
    Color,
    TextAlign.configure({
      types: ["paragraph", "heading", "blockquote"],
      alignments: ["left", "center", "right"]
    }),
    Highlight.configure({ multicolor: true }),
    Indent,
    ArticleSemantics,
    ImagePlaceholder,
    Markdown.configure({ markedOptions: { gfm: true, breaks: false } }),
    PasteMarkdown.configure({ onTitle: onTitleFromPaste })
  ];
}
